import { HeartLineSvg } from "../../components/Svg/Icons/HeartLine";

export const Footer = () => {
  return (
    <div className="bg-primary-light text-center pb-6 text-primary">
      <a
        href="https://es.linkedin.com/in/javier-guisado-pe%C3%B1a-50b051167"
        target="_blank"
        rel="noopener"
      >
        Hecho con todo el{" "}
        <HeartLineSvg
          width="18"
          className="inline"
          color="var(--color-secondary-light)"
        />{" "}
        por Sardinha
      </a>
    </div>
  );
};
